export default {"src":"/_next/static/media/icon-zero.9bc9dc7d.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};